import React from 'react';
import { motion } from 'framer-motion';

const DetailedProcess = ({ steps }) => {
    const cardVariants = {
        hidden: { opacity: 0, y: 50, scale: 0.95 },
        visible: (i) => ({
          opacity: 1,
          y: 0,
          scale: 1,
          transition: {
            delay: i * 0.15,
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }
        })
      };

  return (
    <div className="grid md:grid-cols-2 gap-8">
      {steps.map((step, index) => (
        <motion.div
          key={index}
          className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 flex flex-col items-start text-left"
          custom={index}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="bg-sky-100 text-sky-600 font-bold w-12 h-12 flex items-center justify-center rounded-full mb-5 text-xl">
            {index + 1}
          </div>
          <h3 className="text-xl font-bold text-[#0D2B45] mb-3">{step.title}</h3>
          <p className="text-gray-600">{step.description}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default DetailedProcess; 